import _ from 'lodash';

export const cloneDeep = (object) => {
    return _.cloneDeep(object);
};

export const removeProperty = (object, propertyNames: string[]) => {
    const newObject = { ...object };

    propertyNames.forEach((propertyName: string) => {
        delete newObject[propertyName];
    });

    return newObject;
};
